import { PropsWithChildren, ReactNode } from "react";
import { Button, Card, CardHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

/** the heading style of every sidebar title, also for a custom title element */
export const sidebarTitleClassName = "fs-5 mb-0 text-truncate";

interface Props {
  closeSidebar: () => void;
  /** a text is rendered as heading, an element has to style itself with sidebarTitleClassName */
  title: ReactNode;
  /** rendered below the title, stays visible while the content scrolls */
  actions?: ReactNode;
}

export default function Sidebar(props: PropsWithChildren<Props>) {
  const { t } = useTranslation();

  return (
    <div className="sidebar">
      <Card>
        <CardHeader className="sidebar-header d-flex flex-column gap-2">
          <div className="sidebar-title-row d-flex align-items-center gap-2">
            {/* shown while the sidebar hides the toolbar and the slides (see SongsheetCarousel.css) */}
            <Button
              color="primary"
              className="sidebar-back-button"
              aria-label={t("carousel.toolbar.back")}
              onClick={() => props.closeSidebar()}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
            <div
              className="d-flex align-items-center flex-grow-1"
              style={{ minWidth: 0 }}
            >
              {typeof props.title === "string" ? (
                <h2 className={sidebarTitleClassName}>{props.title}</h2>
              ) : (
                props.title
              )}
            </div>
          </div>
          {props.actions}
        </CardHeader>
        {props.children}
      </Card>
    </div>
  );
}
